import BattleResultTeamMemberStatusRow from "./BattleResultTeamMemberStatusRow";
import { TeamType } from "../Type/TeamType";
import { BattleResultLineTeamType } from "./BattleResultLine";

type Props = {
    team: TeamType,
    battleResult: BattleResultLineTeamType
}

const BattleResultTeamMemberStatus = ({
    team,
    battleResult
}: Props) => {
    return (
        <>
            <BattleResultTeamMemberStatusRow positionType="FRONT"
                heroId={team.front.hero?.id}
                result={battleResult.front}
            />
            <BattleResultTeamMemberStatusRow positionType="MIDDLE"
                heroId={team.middle.hero?.id}
                result={battleResult.middle}
            />
            <BattleResultTeamMemberStatusRow positionType="BACK"
                heroId={team.back.hero?.id}
                result={battleResult.back}
            />
        </>
    );
}

export default BattleResultTeamMemberStatus;